import type { AttendanceStatus } from './types';

export interface AttendanceStatusMeta {
  label: string;
  bg: string;
  text: string;
  darkBg: string;
  darkText: string;
}

const STATUS_META: Record<AttendanceStatus, AttendanceStatusMeta> = {
  SCHEDULED: {
    label: 'Scheduled',
    bg: 'bg-neutral-100', text: 'text-neutral-600',
    darkBg: 'dark:bg-neutral-700/60', darkText: 'dark:text-neutral-300',
  },
  PRESENT: {
    label: 'Present',
    bg: 'bg-success-100', text: 'text-success-700',
    darkBg: 'dark:bg-success-900/30', darkText: 'dark:text-success-300',
  },
  ABSENT: {
    label: 'Absent',
    bg: 'bg-danger-100', text: 'text-danger-700',
    darkBg: 'dark:bg-danger-900/30', darkText: 'dark:text-danger-300',
  },
  LATE: {
    label: 'Late',
    bg: 'bg-amber-100', text: 'text-amber-700',
    darkBg: 'dark:bg-amber-900/30', darkText: 'dark:text-amber-300',
  },
  HALF_DAY: {
    label: 'Half Day',
    bg: 'bg-brand-100', text: 'text-brand-700',
    darkBg: 'dark:bg-brand-900/30', darkText: 'dark:text-brand-300',
  },
  COMPLETED: {
    label: 'Completed',
    bg: 'bg-success-100', text: 'text-success-700',
    darkBg: 'dark:bg-success-900/30', darkText: 'dark:text-success-300',
  },
};

export function attendanceStatusMeta(status: AttendanceStatus): AttendanceStatusMeta {
  return STATUS_META[status] ?? STATUS_META.SCHEDULED;
}
